import { Dispatch } from 'redux';

import { Api } from '../../../api';
import { AppState } from '../../../store/models/app-state';
import { Inquiry } from '../../../common/models/inquiry';
import { Offer } from '../../../common/models/offer';
import { OfferAccountPurchase } from '../../../common/models/offer-account-purchase';
import { OfferStatus } from '../../../common/models/enums/offer-status';

export const RECEIVE_OFFERS = 'RECEIVE_OFFERS';
export const OFFERS_NOT_FOUND = 'OFFERS_NOT_FOUND';
export const REQUEST_OFFERS = 'REQUEST_OFFERS';
export const REQUEST_OFFERS_CANCELED = 'REQUEST_OFFERS_CANCELED';
export const CLEAR_OFFERS = 'CLEAR_OFFERS';
export const UPDATE_OFFER_START = 'UPDATE_OFFER_START';
export const UPDATE_OFFER_END = 'UPDATE_OFFER_END';

const requestOffers = () => {
    return { type: REQUEST_OFFERS };
};

const receiveOffers = (inquiry: Inquiry, offerAccountPurchases: OfferAccountPurchase[]) => {
    return {
        type: RECEIVE_OFFERS,
        inquiry,
        offerAccountPurchases,
    };
};

const requestCanceled = () => {
    return { type: REQUEST_OFFERS_CANCELED };
};

const endUpdate = () => {
    return { type: UPDATE_OFFER_END };
};

const startUpdate = () => {
    return { type: UPDATE_OFFER_START };
};

const offersNotFound = () => {
    return { type: OFFERS_NOT_FOUND };
};

export const clearOffers = () => {
    return { type: CLEAR_OFFERS };
};

export const getOffers = (inquiryId: number, supplierId: number) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch(requestOffers());
        const response = await api.inquiry.get(inquiryId);

        if (!response.success) {
            if (response.requestCanceled) {
                dispatch(requestCanceled());
            }
            if (response.errorCode === 404) {
                dispatch(offersNotFound());
            }
            return;
        }

        const offerAccountPurchases: OfferAccountPurchase[] = [];
        response.result.accountPurchases.forEach(accountPurchase => {
            if (accountPurchase.offers) {
                const offerFound = accountPurchase.offers.find(offer => offer.supplierAccount.id === supplierId);
                if (offerFound) {
                    if (offerFound.status === OfferStatus.Created) {
                        offerFound.offerItems.forEach(item => (item.isOffered = true));
                    }
                    offerAccountPurchases.push({ offer: offerFound, accountPurchase });
                }
            }
        });

        dispatch(receiveOffers(response.result, offerAccountPurchases));
    };
};

export const updateOffers = (inquiryId: number, offers: Offer[]) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch(startUpdate());
        await api.offer.updateOffers(inquiryId, offers);
        dispatch(endUpdate());
    };
};
